import React, { useState } from 'react';
import RegionTile from './RegionTile';
import { propTypes } from './RegionMosaicPropTypes';

const RegionMosaic = ({ regions }) => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleExpand = (state) => {
    setExpandedIndex(expandedIndex !== state.index ? state.index : null);
  };

  return (
    // https://www.w3.org/TR/wai-aria-practices-1.1/examples/accordion/accordion.html
    <section className='region-mosaic'>
      <ul className='region-mosaic__list'>
        {regions &&
          regions.map((region, index) => (
            <li key={index}>
              <RegionTile
                {...region}
                index={index}
                expanded={expandedIndex === index}
                onToggle={!region.disabled && handleExpand}
              />
            </li>
          ))}
      </ul>
    </section>
  );
};

RegionMosaic.propTypes = propTypes;

export default RegionMosaic;
